export interface GradeArgs {
  id?: number;
  name: string;
  hotel_price_limit: number | null;
  foreign_hotel_price_limit: number | null;
  weight: number;
  default_seat_classes: string[]; // note: grade.as_jsonを呼ばないと `default_seat_class: "M,W,C,F"` のように返ってくる
  shinkansen_seat_types: shinkansenSeatType[]; // note: grade.as_jsonを呼ばないと `shinkansen_seat_type: "free,reserve,green" のように返ってくる
  shinkansen_seat_type?: string;
  default_ticket_type: TicketType;
  domestic_daily_allowance_with_stay: number | null;
  domestic_daily_allowance_without_stay: number | null;
  foreign_daily_allowance_with_stay: number | null;
  lodging_check: boolean;
  domestic_air_seat_upgrade: boolean;
  allow_breakfast_domestic_hotel: boolean;
  allow_breakfast_foreign_hotel: boolean;
  show_multiple_hotel_plans_domestic: boolean;
  show_multiple_hotel_plans_foreign: boolean;
}

export type shinkansenSeatType = 'free' | 'reserve' | 'green';

export type TicketType = 'changeable' | 'unchangeable';

class Grade {
  public id: number | null;

  public name: string;

  public hotelPriceLimit: number | null;

  public foreignHotelPriceLimit: number | null;

  public weight: number;

  public defaultSeatClasses: string[];

  public shinkansenSeatTypes: shinkansenSeatType[];

  public defaultTicketType: TicketType;

  public domesticDailyAllowanceWithStay: number | null;

  public domesticDailyAllowanceWithoutStay: number | null;

  public foreignDailyAllowanceWithStay: number | null;

  public lodgingCheck: boolean;

  public domesticAirSeatUpgrade: boolean;

  public allowBreakfastDomesticHotel: boolean;

  public allowBreakfastForeignHotel: boolean;

  public showMultipleHotelPlansDomestic: boolean;

  public showMultipleHotelPlansForeign: boolean;

  constructor(args: GradeArgs) {
    this.id = args.id || null;
    this.name = args.name;
    this.hotelPriceLimit = args.hotel_price_limit;
    this.foreignHotelPriceLimit = args.foreign_hotel_price_limit;
    this.weight = args.weight;
    this.defaultSeatClasses = args.default_seat_classes;
    this.shinkansenSeatTypes = args.shinkansen_seat_types;
    this.defaultTicketType = args.default_ticket_type;
    this.domesticDailyAllowanceWithStay = args.domestic_daily_allowance_with_stay;
    this.domesticDailyAllowanceWithoutStay = args.domestic_daily_allowance_without_stay;
    this.foreignDailyAllowanceWithStay = args.foreign_daily_allowance_with_stay;
    this.lodgingCheck = args.lodging_check;
    this.domesticAirSeatUpgrade = args.domestic_air_seat_upgrade;
    this.allowBreakfastDomesticHotel = args.allow_breakfast_domestic_hotel;
    this.allowBreakfastForeignHotel = args.allow_breakfast_foreign_hotel;
    this.showMultipleHotelPlansDomestic = args.show_multiple_hotel_plans_domestic;
    this.showMultipleHotelPlansForeign = args.show_multiple_hotel_plans_foreign;
  }

  submitParams() {
    return {
      id: this.id,
      name: this.name,
      hotel_price_limit: this.hotelPriceLimit,
      foreign_hotel_price_limit: this.foreignHotelPriceLimit,
      weight: this.weight,
      default_seat_classes: this.defaultSeatClasses,
      shinkansen_seat_types: this.shinkansenSeatTypes,
      default_ticket_type: this.defaultTicketType,
      domestic_daily_allowance_with_stay: this.domesticDailyAllowanceWithStay,
      domestic_daily_allowance_without_stay: this.domesticDailyAllowanceWithoutStay,
      foreign_daily_allowance_with_stay: this.foreignDailyAllowanceWithStay,
      lodging_check: this.lodgingCheck,
      domestic_air_seat_upgrade: this.domesticAirSeatUpgrade,
      allow_breakfast_domestic_hotel: this.allowBreakfastDomesticHotel,
      allow_breakfast_foreign_hotel: this.allowBreakfastForeignHotel,
      show_multiple_hotel_plans_domestic: this.showMultipleHotelPlansDomestic,
      show_multiple_hotel_plans_foreign: this.showMultipleHotelPlansForeign
    };
  }

  setName(value: string) {
    this.name = value;
    app.render();
  }

  setHotelPriceLimit(value: number) {
    this.hotelPriceLimit = value;
    app.render();
  }

  setForeignHotelPriceLimit(value: number) {
    this.foreignHotelPriceLimit = value;
    app.render();
  }

  setDomesticDailyAllowanceWithStay(value: number) {
    this.domesticDailyAllowanceWithStay = value;
    app.render();
  }

  setDomesticDailyAllowanceWithoutStay(value: number) {
    this.domesticDailyAllowanceWithoutStay = value;
    app.render();
  }

  setForeignDailyAllowanceWithStay(value: number) {
    this.foreignDailyAllowanceWithStay = value;
    app.render();
  }

  setLodgingCheck(value: boolean) {
    this.lodgingCheck = value;
    app.render();
  }

  setDomesticAirSeatUpgradeCheck(value: boolean) {
    this.domesticAirSeatUpgrade = value;
    app.render();
  }

  setAllowBreakfastDomesticHotel(value: boolean) {
    this.allowBreakfastDomesticHotel = value;
    app.render();
  }

  setAllowBreakfastForeignHotel(value: boolean) {
    this.allowBreakfastForeignHotel = value;
    app.render();
  }

  setShowMultipleHotelPlansDomestic(value: boolean) {
    this.showMultipleHotelPlansDomestic = value;
    app.render();
  }

  setShowMultipleHotelPlansForeign(value: boolean) {
    this.showMultipleHotelPlansForeign = value;
    app.render();
  }
}

export default Grade;
